// Instalación PWA: usa el diálogo del navegador si lo ofrece; si no, la interfaz muestra instrucciones.
import { api } from "@/lib/api";
import { isStandalone } from "@/lib/push";
const AVISO = "aldia-instalacion";
const avisar = () => window.dispatchEvent(new Event(AVISO));

export const escucharInstalacion = () => {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); window.__aldiaInstallPrompt = e; window.__aldiaInstalable = true; avisar(); });
  window.addEventListener("appinstalled", () => {
    window.__aldiaInstallPrompt = null;
    localStorage.setItem("aldia_instalada", "1");
    avisar();
  });
};

export const onCambioInstalacion = (fn) => { window.addEventListener(AVISO, fn); return () => window.removeEventListener(AVISO, fn); };
export const hayDialogoInstalacion = () => !!window.__aldiaInstallPrompt;
export const instaladaEnEsteEquipo = () => localStorage.getItem("aldia_instalada") === "1";

// Chrome puede indicar si la app ya está instalada (manifest.related_applications).
export const comprobarInstalada = async () => {
  if (instaladaEnEsteEquipo()) return true;
  try {
    const apps = navigator.getInstalledRelatedApps ? await navigator.getInstalledRelatedApps() : [];
    if (apps.length) { localStorage.setItem("aldia_instalada", "1"); return true; }
  } catch { /* sin soporte */ }
  return false;
};

// Devuelve "aceptada" | "rechazada" | "no-disponible" | "error".
export const lanzarInstalacion = async () => {
  const p = window.__aldiaInstallPrompt;
  if (!p) return "no-disponible";
  window.__aldiaInstallPrompt = null; // cada evento solo puede usarse una vez
  try {
    await p.prompt();
    const { outcome } = await p.userChoice;
    avisar();
    return outcome === "accepted" ? "aceptada" : "rechazada";
  } catch {
    avisar();
    return "error";
  }
};

export const AYUDA_MENU_CHROME = "Puedes instalar AL DÍA desde el menú de Google Chrome. Busca la opción Instalar aplicación o una opción equivalente, según tu versión del navegador.";

// Informe técnico anónimo (solo al pulsar un botón de la tarjeta): navegador, sistema y resultado.
const navegador = () => {
  const b = (navigator.userAgentData?.brands || []).find((x) => /Chrome|Edge/.test(x.brand));
  if (b) return `${b.brand.replace("Google ", "").replace("Microsoft ", "")} ${b.version}`;
  const m = navigator.userAgent.match(/(Edg|Chrome|Firefox|Version)\/(\d+)/);
  return m ? `${m[1] === "Edg" ? "Edge" : m[1] === "Version" ? "Safari" : m[1]} ${m[2]}` : "otro";
};
const sistema = async () => {
  try {
    const v = await navigator.userAgentData?.getHighEntropyValues?.(["platformVersion"]);
    if (v?.platform === "Windows") return Number(v.platformVersion.split(".")[0]) >= 13 ? "Windows 11" : "Windows 10";
    if (v?.platform) return v.platform;
  } catch { /* sin soporte */ }
  return /Windows/.test(navigator.userAgent) ? "Windows" : /Mac OS/.test(navigator.userAgent) ? "macOS" : "otro";
};
const yaInstalada = async () => {
  if (!navigator.getInstalledRelatedApps) return "sin dato";
  try { return (await navigator.getInstalledRelatedApps()).length ? "sí" : "no detectada"; } catch { return "sin dato"; }
};
export const enviarDiagnostico = async (accion, resultado = "") => {
  try {
    await api.post("/diagnostico-instalacion", {
      navegador: navegador(), sistema: await sistema(), ventana: isStandalone() ? "app" : "navegador",
      ofrecio_instalar: !!window.__aldiaInstalable, ya_instalada: await yaInstalada(), accion, resultado,
    });
  } catch { /* el informe nunca bloquea la instalación */ }
};
